export const PopupPositionPattern = {
  AT_RIGHT_ANCHOR_SIDE: "right",
};

export const DATA_ATTR_HIDE_POPUP_ON_CLICK = "data-hide-popup";
